import React from 'react'

const Community = () => {
  return (
    <div>Community Hub</div>
  )
}

export default Community